import * as React from "react";

function SvgIcon4(props) {
  return (
    <svg {...props} viewBox="0 0 100 100">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFCD00"
          d="M45 40a9 9 0 119-9v9h-9zm27 0a9 9 0 10-9-9v9h9z"
        />
        <path fill="#FFCD00" d="M43 22h10v18H43zm28 0h12v18H71z" />
        <path
          fill="#62C8A5"
          d="M54 40a9 9 0 119-9v9h-9zm28 0a9 9 0 10-9-9v9h9z"
        />
        <path fill="#EE451F" d="M13 42h80v60H13z" />
        <path fill="#FF7200" d="M13 40h80v60H13z" />
        <path fill="#FFCD00" d="M63 35h10v67H63z" />
        <path fill="#FF9000" d="M63 100h10v2H63z" />
        <path
          fill="#FFCD00"
          d="M61 64v10H13V64zm32 0v10H75V64zM0 40.115a13.272 13.272 0 010-.23c.531.076 1.073.115 1.625.115C7.907 40 13 34.907 13 28.625c0-.552-.04-1.094-.115-1.625a13.273 13.273 0 01.23 0A11.459 11.459 0 0013 28.625C13 34.907 18.093 40 24.375 40c.552 0 1.094-.04 1.625-.115a13.273 13.273 0 010 .23A11.472 11.472 0 0024.375 40C18.093 40 13 45.093 13 51.375c0 .552.04 1.094.115 1.625a13.273 13.273 0 01-.23 0c.076-.531.115-1.073.115-1.625C13 45.093 7.907 40 1.625 40c-.552 0-1.094.04-1.625.115z"
        />
        <path
          fill="#62C8A5"
          d="M19 7.566a7.655 7.655 0 010-.132A6.562 6.562 0 0026.433 0a7.657 7.657 0 01.133 0A6.562 6.562 0 0034 7.433a7.655 7.655 0 010 .132A6.562 6.562 0 0026.567 15a7.655 7.655 0 01-.132 0A6.562 6.562 0 0019 7.567z"
        />
        <path
          fill="#FF9000"
          d="M37 22.54a4.594 4.594 0 010-.08A3.938 3.938 0 0041.46 18a4.594 4.594 0 01.08 0A3.938 3.938 0 0046 22.46a4.594 4.594 0 010 .08A3.938 3.938 0 0041.54 27a4.594 4.594 0 01-.08 0A3.938 3.938 0 0037 22.54z"
        />
      </g>
    </svg>
  );
}

export default SvgIcon4;
